import React from "react";
import LoadingComponent from "@Components/LoadingComponent/LoadingComponent";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Box,
} from "@mui/material";
import PageTitle from "../PageTitle/PageTitle";
import themeCreator from "../../Themes/themeCreator";
import { SimpleNotesPopup } from "@Components/SimpleNotesPopup/SimpleNotesPopup";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import InfoIcon from "@mui/icons-material/Info";
import { useState } from "react";
const GenericPopup = ({
  open,
  sx,
  title,
  content,
  buttons,
  maxWidth,
  noteData = null,
  icon, // Add icon prop
  dialogContentSx = {},
  dialogActionsSx = {},
  loading = false,
}) => {
  const theme = themeCreator();

  const [openNotePoints, setOpenNotePoints] = useState(false);

  const handleClickOpen = () => {
    setOpenNotePoints(true);
  };

  const handleClose = () => {
    setOpenNotePoints(false);
  };

  return (
    <>
      <Dialog open={open} sx={sx} fullWidth maxWidth={maxWidth || "md"}>
        <DialogTitle fontWeight={"bold"}>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
          >
            <PageTitle
              title={title}
              PageIcon={icon} // Add icon prop
              iconColor={theme.palette.primary.main}
              breadcrumbs={false}
            />
            {noteData && (
              <Tooltip title="Notes Popup">
                <IconButton color="info" onClick={handleClickOpen} size="small">
                  <InfoIcon
                    sx={{ color: "primary !important", fontSize: 29 }}
                  />
                </IconButton>
              </Tooltip>
            )}
          </Box>
        </DialogTitle>

        <DialogContent sx={dialogContentSx}>
          {loading ? (
            <LoadingComponent size="5em" thickness={5} color={"primary"} />
          ) : (
            content
          )}
        </DialogContent>
        <DialogActions sx={dialogActionsSx}>
          {buttons.map((button) => (
            <Button
              key={button.text}
              onClick={button.onClick}
              color={button.color}
              variant={button.variant}
              disabled={button.loading || loading || false || button.disabled}
            >
              {!button.loading ? (
                button.text
              ) : (
                <LoadingComponent
                  size="2em"
                  thickness={5}
                  color={button.color}
                />
              )}
            </Button>
          ))}
        </DialogActions>
      </Dialog>
      {noteData && (
        <SimpleNotesPopup
          openNotePoints={openNotePoints}
          onClose={handleClose}
          noteData={noteData}
        />
      )}
    </>
  );
};

export default GenericPopup;
